/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_PurchaseInputs */

const en_settings_credits_purchase = /** @type {(inputs: Settings_Credits_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase Credits`)
};

/**
* | output |
* | --- |
* | "Purchase Credits" |
*
* @param {Settings_Credits_PurchaseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_purchase = /** @type {((inputs?: Settings_Credits_PurchaseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_PurchaseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_purchase(inputs)
});
export { settings_credits_purchase as "settings.credits.purchase" }